// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-root {
    background-color: #151138;
    flex-direction: row;
    width: -webkit-fill-available;
    height: 4vh;
    color: white;
    padding: 2vh;
    padding-left: 5vh;
  }
  
  .header-left {
    float: left;
    font-weight: 650;
    letter-spacing: 1px;
  }
  
  .header-right {
    float: right;
    display: flex;
  }
  
  .header-user-icon {
    width: 4vh;
    margin-left: 2vh;
  }
  
  .gradient-line {
      border: 0;
      height: 3px;
      background: linear-gradient(90deg, #3e3b56 25%, #fc2b23 90%);
      border-radius: 5px;
    }
    
    `, "",{"version":3,"sources":["webpack://./src/components/header/Header.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;MACI,SAAS;MACT,WAAW;MACX,4DAA4D;MAC5D,kBAAkB;IACpB","sourcesContent":[".header-root {\n    background-color: #151138;\n    flex-direction: row;\n    width: -webkit-fill-available;\n    height: 4vh;\n    color: white;\n    padding: 2vh;\n    padding-left: 5vh;\n  }\n  \n  .header-left {\n    float: left;\n    font-weight: 650;\n    letter-spacing: 1px;\n  }\n  \n  .header-right {\n    float: right;\n    display: flex;\n  }\n  \n  .header-user-icon {\n    width: 4vh;\n    margin-left: 2vh;\n  }\n  \n  .gradient-line {\n      border: 0;\n      height: 3px;\n      background: linear-gradient(90deg, #3e3b56 25%, #fc2b23 90%);\n      border-radius: 5px;\n    }\n    \n    "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
